/**
 * Main Application Router
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { AdminRoute } from './AdminRoute';
import { ROUTES } from '../utils/constants';

// Pages
import LoginPage from '../pages/Auth/LoginPage';
import RegisterPage from '../pages/Auth/RegisterPage';
import ResetPasswordPage from '../pages/Auth/ResetPasswordPage';
import VerifyEmailPage from '../pages/Auth/VerifyEmailPage';
import LandingPage from '../pages/Landing/LandingPage';
import PricingPage from '../pages/Pricing/PricingPage';
import DashboardPage from '../pages/Dashboard/DashboardPage';
import QRCodePage from '../pages/Dashboard/QRCodePage';
import { QRCodeDetailPage } from '../pages/Dashboard/QRCodeDetailPage/index';
import { SampleQRCodeDetailPage } from '../pages/Dashboard/QRCodeDetailPage/SampleQRCodeDetailPage';
import SampleQRCodeEditPage from '../pages/Dashboard/SampleQRCodeEditPage';
import { SAMPLE_QR_SHORT_CODE } from '../data/sampleQrCode';
import QRCodeEditPage from '../pages/Dashboard/QRCodeEditPage';
import UserProfilePage from '../pages/Dashboard/UserProfilePage';
import BillingPage from '../pages/Dashboard/BillingPage';
import APIKeysPage from '../pages/Dashboard/APIKeysPage';
import MyImagesPage from '../pages/Dashboard/MyImagesPage';
import UserManagementPage from '../pages/Admin/UserManagementPage';
import DesignSystemPage from '../pages/DesignSystem/DesignSystemPage';
import PasswordPage from '../pages/QR/PasswordPage';
import ExpiredPage from '../pages/QR/ExpiredPage';
import LimitReachedPage from '../pages/QR/LimitReachedPage';
import RedirectPage from '../pages/QR/RedirectPage';

export const AppRouter = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path={ROUTES.HOME} element={<LandingPage />} />
      <Route path={ROUTES.PRICING} element={<PricingPage />} />
      <Route path={ROUTES.LOGIN} element={<LoginPage />} />
      <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/r/:shortCode" element={<RedirectPage />} />
      <Route path="/password/:shortCode" element={<PasswordPage />} />
      <Route path="/expired/:shortCode" element={<ExpiredPage />} />
      <Route path="/limit-reached/:shortCode" element={<LimitReachedPage />} />
      <Route path="/_design_system" element={<DesignSystemPage />} />

      {/* Protected Routes */}
      <Route
        path={ROUTES.DASHBOARD}
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.QR_CODES}
        element={
          <ProtectedRoute>
            <QRCodePage />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.QR_CODES}/:id/edit`}
        element={
          <ProtectedRoute>
            <QRCodeEditPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.QR_CODES}/${SAMPLE_QR_SHORT_CODE}/edit`}
        element={
          <ProtectedRoute>
            <SampleQRCodeEditPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.QR_CODES}/${SAMPLE_QR_SHORT_CODE}`}
        element={
          <ProtectedRoute>
            <SampleQRCodeDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.QR_CODES}/:id`}
        element={
          <ProtectedRoute>
            <QRCodeDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <UserProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/billing"
        element={
          <ProtectedRoute>
            <BillingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/api-keys"
        element={
          <ProtectedRoute>
            <APIKeysPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.IMAGES}
        element={
          <ProtectedRoute>
            <MyImagesPage />
          </ProtectedRoute>
        }
      />

      {/* Admin Routes */}
      <Route
        path="/admin/users"
        element={
          <AdminRoute>
            <UserManagementPage />
          </AdminRoute>
        }
      />

      {/* 404 - Catch all - redirect to home */}
      <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
    </Routes>
  );
};

